import type { FieldConfig } from '@/components/TimesheetReports/FieldSelector';
import type { PostingLineDisplayStatus, PostingStatus } from '@/utils/PostingLog/types';

export const STATUS_OPTIONS: { value: PostingStatus; label: string }[] = [
  { value: 'Posted', label: 'Posted' },
  { value: 'Failed', label: 'Failed' },
];

export const STATUS_CONFIG: Record<PostingLineDisplayStatus, { badgeClass: string }> = {
  Posted:  { badgeClass: 'bg-success-100 text-success-800 dark:bg-success-900/40 dark:text-success-300' },
  Failed:  { badgeClass: 'bg-error-100 text-error-800 dark:bg-error-900/40 dark:text-error-300' },
  'Not posted': { badgeClass: 'bg-neutral-100 text-neutral-800 dark:bg-neutral-700 dark:text-neutral-200' },
};

export const POSTING_DEFAULT_COLUMNS: FieldConfig[] = [
  { id: 'timesheetId',          label: 'Timesheet',    visible: true,  order: 0, category: 'Reference' },
  { id: 'employeeName',         label: 'Employee',     visible: true,  order: 1, category: 'People' },
  { id: 'weekEnding',           label: 'Week Ending',  visible: true,  order: 2, category: 'Time Period' },
  { id: 'erpRef',               label: 'ERP Ref.',     visible: true,  order: 3, category: 'Reference' },
  { id: 'status',               label: 'Status',       visible: true,  order: 4, category: 'Status' },
];

export const PAGE_SIZE = 50;
